<div class="badge" #badge>
  <span>{{value}}</span>
</div>
